import { MutationTree } from 'vuex'
import { PlcOperationStateHistoryItemModel } from './models'
import { PlcConnectionMutation, PlcConnectionState } from './types'

export const mutations: MutationTree<PlcConnectionState> = {
  [PlcConnectionMutation.setPlcOperationStateHistory](state, payload: PlcOperationStateHistoryItemModel[]) {
    state.plcOperationStateHistory = payload
  },
}
